import { render, staticRenderFns } from "./XTableMagnify.vue?vue&type=template&id=69bd95e9&scoped=true&"
import script from "./XTableMagnify.vue?vue&type=script&lang=js&"
export * from "./XTableMagnify.vue?vue&type=script&lang=js&"
import style0 from "./XTableMagnify.vue?vue&type=style&index=0&id=69bd95e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bd95e9",
  null
  
)

export default component.exports